import { BaseSelectFilter } from '../shared/base-select-filter';

const options = [
  { id: '1', label: 'True', value: 1 },
  { id: '2', label: 'False', value: 2 },
];

export function CompactFilter({
  autoSelectIfEmpty,
  useContextFn,
  error,
  errorMessages = {},
}: {
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    compact: number;
    setCompact: (value: number) => void;
  };
  error?: boolean;
  errorMessages?: Record<string, string>;
}) {
  const { compact: value, setCompact: onChange } = useContextFn();
  const helperText = errorMessages['compact'];
  return (
    <BaseSelectFilter
      autoSelectIfEmpty={autoSelectIfEmpty}
      label="Compact"
      options={options}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
    />
  );
}
